define([], function() {
	var Observers = {};

	var ObserverHandler = function(id) {
		var observer = Observers[id];

		if (Observers[id]) {
			return observer;
		} else {
			var callbacks = $.Callbacks("unique"),
				ob = {}

			Observers[id] = {
				add: function(key) {
					if (!ob[key]) {
						var cb = $.Callbacks("unique");
						ob[key] = {
							subscribe: cb.add,

							publish: cb.fire,

							unsubscribe: cb.remove,

							unsubscribeAll: cb.empty,

							has: cb.has
						}
					}
					return ob[key];
				},

				get: function(key) {
					return ob[key];
				},

				subscribe: callbacks.add,

				publish: callbacks.fire,

				unsubscribe: callbacks.remove,

				unsubscribeAll: callbacks.empty,

				has: callbacks.has
			}

			return Observers[id];
		}
	}

	return ObserverHandler;
})



/** WEBPACK FOOTER **
 ** ./src/scripts/utils/observer.js
 **/